import {apiClient} from '@/shared/services/apiClient';

export type MenopausalStatus = 'pre' | 'post';

export interface ProviderPatientProfile {
    id: number;
    firstName: string;
    lastName: string;
    birthday: string | null;
    gender: string | null;
    ethnicity: string | null;
    menopausalStatus: MenopausalStatus | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
}

export interface ProviderPatientUpdate {
    firstName?: string;
    lastName?: string;
    birthday?: string | null;
    gender?: string | null;
    ethnicity?: string | null;
    menopausalStatus?: MenopausalStatus | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
}

export const ProviderPatientsService = {
    async getProfile(userId: number): Promise<ProviderPatientProfile> {
        return apiClient.get<ProviderPatientProfile>(`/api/provider/patient/${userId}/profile`);
    },

    async updateProfile(userId: number, updates: ProviderPatientUpdate): Promise<ProviderPatientProfile> {
        return apiClient.patch<ProviderPatientProfile>(`/api/provider/patient/${userId}`, updates);
    },
};
